const API_URL = process.env.REACT_APP_API_URL;

/**
 * Obtiene las preguntas dinámicas activas sanitizadas para la vista del aficionado.
 */
const GetTriviaQuestions = async () => {
    try {
        const response = await fetch(`${API_URL}MvpXolosZone/trivia`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const err = await response.json().catch(() => ({}));
            return { success: false, message: err.message || 'Error al obtener las preguntas de la trivia.' };
        }
        const data = await response.json();
        return { success: true, data: data.data || [] };
    } catch (error) {
        console.error("Error en GetTriviaQuestions:", error);
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

/**
 * Envía las respuestas del aficionado para su evaluación atómica.
 */
const SubmitTrivia = async (payload) => {
    try {
        const response = await fetch(`${API_URL}MvpXolosZone/submit`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
        const resData = await response.json().catch(() => ({}));
        if (!response.ok) {
            return { 
                success: false, 
                message: resData.message || 'Error al enviar la trivia.' 
            };
        }
        return resData;
    } catch (error) {
        console.error("Error en SubmitTrivia:", error);
        return { success: false, message: 'Error de conexión al enviar la trivia.' };
    }
};

/**
 * Registra eventos de telemetría del embudo (escaneo, inicio de formulario, etc.).
 */
const TrackMetric = async (eventName, sessionId = null, source = null) => {
    try {
        const response = await fetch(`${API_URL}MvpXolosZone/metric`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ eventName, sessionId, source })
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false };
    }
};

/**
 * Consulta la configuración pública o del partido.
 */
const GetPublicConfig = async () => {
    try {
        const response = await fetch(`${API_URL}MvpXolosZone/admin/config`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data: data.data };
    } catch (error) {
        return { success: false };
    }
};

/**
 * Consulta y recupera un pase ganado por correo o teléfono con Rate Limiting.
 */
const RecoverPass = async (query) => {
    try {
        const response = await fetch(`${API_URL}MvpXolosZone/recover-pass`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ query })
        });
        const resData = await response.json().catch(() => ({}));
        if (response.status === 429) {
            return {
                success: false,
                isRateLimited: true,
                waitSeconds: resData.waitSeconds || 60,
                message: resData.message || 'Límite de consultas excedido. Por favor espera un momento.'
            };
        }
        if (!response.ok) {
            return {
                success: false,
                message: resData.message || 'Error al consultar el pase.'
            };
        }
        return resData;
    } catch (error) {
        console.error("Error en RecoverPass:", error);
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

/**
 * Obtiene la configuración completa para el panel administrativo.
 */
const GetAdminConfig = async () => {
    try {
        const response = await fetch(`${API_URL}MvpXolosZone/admin/config`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error en GetAdminConfig:", error);
        return { success: false, message: 'Error al obtener la configuración administrativa.' };
    }
};

/**
 * Actualiza la configuración de la dinámica.
 */
const UpdateAdminConfig = async (payload) => {
    try {
        const response = await fetch(`${API_URL}MvpXolosZone/admin/config`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error en UpdateAdminConfig:", error);
        return { success: false, message: 'Error al actualizar la configuración.' };
    }
};

/**
 * Obtiene el listado de preguntas con respuestas y opciones para el administrador.
 */
const GetAdminQuestions = async () => {
    try {
        const response = await fetch(`${API_URL}MvpXolosZone/admin/questions`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error en GetAdminQuestions:", error);
        return { success: false, message: 'Error al obtener las preguntas para administración.' };
    }
};

/**
 * Guarda (crea o edita) una pregunta con sus opciones.
 */
const SaveAdminQuestion = async (payload) => {
    try {
        const response = await fetch(`${API_URL}MvpXolosZone/admin/questions`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error en SaveAdminQuestion:", error);
        return { success: false, message: 'Error al guardar la pregunta.' };
    }
};

/**
 * Elimina una pregunta por ID.
 */
const DeleteAdminQuestion = async (id) => {
    try {
        const response = await fetch(`${API_URL}MvpXolosZone/admin/questions/${id}`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error en DeleteAdminQuestion:", error);
        return { success: false, message: 'Error al eliminar la pregunta.' };
    }
};

/**
 * Obtiene los participantes con filtros y búsqueda.
 */
const GetAdminParticipants = async (filter = '', search = '') => {
    try {
        const params = new URLSearchParams();
        if (filter) params.append('filter', filter);
        if (search) params.append('search', search);

        const response = await fetch(`${API_URL}MvpXolosZone/admin/participants?${params.toString()}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error en GetAdminParticipants:", error);
        return { success: false, message: 'Error al obtener la lista de participantes.' };
    }
};

/**
 * Obtiene las estadísticas de embudo y estado de pases.
 */
const GetAdminStats = async () => {
    try {
        const response = await fetch(`${API_URL}MvpXolosZone/admin/stats`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error en GetAdminStats:", error);
        return { success: false, message: 'Error al obtener estadísticas.' };
    }
};

/**
 * Descalifica a un participante.
 */
const DisqualifyParticipant = async (participantId, reason, operator = null) => {
    try {
        const response = await fetch(`${API_URL}MvpXolosZone/admin/disqualify`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ participantId, reason, operator })
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error en DisqualifyParticipant:", error);
        return { success: false, message: 'Error al descalificar al participante.' };
    }
};

/**
 * Remueve la descalificación de un participante.
 */
const UndisqualifyParticipant = async (participantId, operator = null) => {
    try {
        const response = await fetch(`${API_URL}MvpXolosZone/admin/undisqualify`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ participantId, operator })
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error en UndisqualifyParticipant:", error);
        return { success: false, message: 'Error al remover la descalificación.' };
    }
};

/**
 * Reinicia la dinámica por completo.
 */
const ResetDynamic = async () => {
    try {
        const response = await fetch(`${API_URL}MvpXolosZone/admin/reset`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error en ResetDynamic:", error);
        return { success: false, message: 'Error al reiniciar la dinámica.' };
    }
};

/**
 * Realiza el check-in de un pase escaneado en el acceso a cancha (Túnel 2).
 */
const CheckinParticipant = async (scanData, operator = null) => {
    try {
        const response = await fetch(`${API_URL}MvpXolosZone/admin/checkin`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ scanData, operator })
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error en CheckinParticipant:", error);
        return { success: false, status: "ERROR", message: 'Error de conexión al validar el pase.' };
    }
};

/**
 * Actualiza la visibilidad del overlay en tiempo real (OBS / Pantallas).
 * @param {boolean} isVisible
 */
const SetOverlayVisibilityDL = async (isVisible) => {
    try {
        const response = await fetch(`${API_URL}MvpXolosZone/admin/overlay-visibility`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ isVisible })
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
            return await UpdateAdminConfig({ isOverlayVisible: isVisible });
        }
        return data;
    } catch (error) {
        console.error("Error en SetOverlayVisibilityDL:", error);
        return await UpdateAdminConfig({ isOverlayVisible: isVisible });
    }
};

/**
 * Actualiza el offset vertical del overlay en tiempo real (OBS / Pantallas).
 * @param {number} offsetY
 */
const SetOverlayOffsetDL = async (offsetY) => {
    try {
        const response = await fetch(`${API_URL}MvpXolosZone/admin/overlay-config`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ offsetY })
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
            return await UpdateAdminConfig({ offsetY });
        }
        return data;
    } catch (error) {
        console.error("Error en SetOverlayOffsetDL:", error);
        return await UpdateAdminConfig({ offsetY });
    }
};

/**
 * Verifica si un aficionado ya participó previamente por correo, teléfono o nombre.
 */
const CheckDuplicateParticipant = async (email, phone, name) => {
    try {
        const response = await fetch(`${API_URL}MvpXolosZone/check-duplicate`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, phone, name })
        });
        if (!response.ok) {
            const err = await response.json().catch(() => ({}));
            return { success: false, message: err.message || 'Error al verificar duplicidad.' };
        }
        const data = await response.json();
        return { success: true, exists: Boolean(data.exists) };
    } catch (error) {
        console.error("Error en CheckDuplicateParticipant:", error);
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

/**
 * Registra la captura de pantalla o descarga del pase realizada por el aficionado.
 */
const LogScreenshot = async (participantId, passCode, name, method) => {
    try {
        const response = await fetch(`${API_URL}MvpXolosZone/log-screenshot`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ participantId, passCode, name, method })
        });
        if (!response.ok) return { success: false };
        const data = await response.json().catch(() => ({}));
        return { success: true, data };
    } catch (error) {
        console.error("Error en LogScreenshot:", error);
        return { success: false };
    }
};

/**
 * Obtiene el dataset completo administrativo para exportación multi-hoja a Excel.
 */
const GetExportDataset = async () => {
    try {
        const response = await fetch(`${API_URL}MvpXolosZone/admin/export-dataset`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const err = await response.json().catch(() => ({}));
            return { success: false, message: err.message || 'Error al obtener datos de exportación.' };
        }
        const data = await response.json();
        return { success: true, data: data.data };
    } catch (error) {
        console.error("Error en GetExportDataset:", error);
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

/**
 * Sube un archivo multimedia o cintillo para la dinámica.
 * @param {File|Blob|FormData} file - Archivo a subir.
 * @param {string|null} [category=null] - Categoría opcional del medio.
 * @returns {Promise<{success: boolean, url?: string, message?: string}>}
 */
const UploadMedia = async (file, category = null) => {
    try {
        if (!file) {
            return { success: false, message: 'No se ha seleccionado ningún archivo.' };
        }

        let formData;
        if (file instanceof FormData) {
            formData = file;
        } else {
            formData = new FormData();
            formData.append('file', file);
            if (category) {
                formData.append('category', category);
                if (category === 'banner_lg' || category === '1920') {
                    formData.append('resolution', '1920');
                } else if (category === 'banner_md' || category === '1536') {
                    formData.append('resolution', '1536');
                }
            }
        }

        const response = await fetch(`${API_URL}MvpXolosZone/admin/upload-media`, {
            method: 'POST',
            body: formData
        });

        const data = await response.json().catch(() => ({}));
        if (!response.ok || data.success === false) {
            // Intentar fallback a upload-banner si upload-media no estuviera disponible
            const fallbackResponse = await fetch(`${API_URL}MvpXolosZone/admin/upload-banner`, {
                method: 'POST',
                body: formData
            });
            const fallbackData = await fallbackResponse.json().catch(() => ({}));
            if (!fallbackResponse.ok || fallbackData.success === false) {
                return { success: false, message: data.message || fallbackData.message || 'Error al subir el archivo.' };
            }
            return { success: true, url: fallbackData.url };
        }

        return { success: true, url: data.url };
    } catch (error) {
        console.error("Error en UploadMedia DL:", error);
        return { success: false, message: 'Error de conexión al subir el archivo.' };
    }
};

export {
    GetTriviaQuestions,
    SubmitTrivia,
    CheckDuplicateParticipant,
    LogScreenshot,
    GetExportDataset,
    TrackMetric,
    GetPublicConfig,
    RecoverPass,
    GetAdminConfig,
    UpdateAdminConfig,
    GetAdminQuestions,
    SaveAdminQuestion,
    DeleteAdminQuestion,
    GetAdminParticipants,
    GetAdminStats,
    DisqualifyParticipant,
    UndisqualifyParticipant,
    ResetDynamic,
    CheckinParticipant,
    SetOverlayVisibilityDL,
    SetOverlayOffsetDL,
    UploadMedia
};

